"use client"

import { useEffect } from "react"
import { usePathname } from "next/navigation"
import { useMultiLanguages } from "./MultiLanguageContext"

export default function LocaleGuard() {
  const pathname = usePathname()
  const { setLocale, locale } = useMultiLanguages()

  const showLanguageSwitcher = ["/profil", "/berita", "/news"].some(
    route => pathname === route || pathname.startsWith(route + "/")
  )

  useEffect(() => {
    if (!showLanguageSwitcher && locale !== "id") {
      setLocale("id")
    }
  }, [pathname, showLanguageSwitcher, locale, setLocale])

  return null
}
